module.exports = __webpack_public_path__ + "static/media/Follower_Button-9.e6023a0b.png";